__turbopack_context__.v({
  "badge": "pricing-page-module__OyZ0Nq__badge",
  "benefitGrid": "pricing-page-module__OyZ0Nq__benefitGrid",
  "bilingual": "pricing-page-module__OyZ0Nq__bilingual",
  "checkStatus": "pricing-page-module__OyZ0Nq__checkStatus",
  "compareSection": "pricing-page-module__OyZ0Nq__compareSection",
  "comparison": "pricing-page-module__OyZ0Nq__comparison",
  "comparisonHead": "pricing-page-module__OyZ0Nq__comparisonHead",
  "comparisonRow": "pricing-page-module__OyZ0Nq__comparisonRow",
  "excludedStatus": "pricing-page-module__OyZ0Nq__excludedStatus",
  "eyebrow": "pricing-page-module__OyZ0Nq__eyebrow",
  "ghostButton": "pricing-page-module__OyZ0Nq__ghostButton",
  "hero": "pricing-page-module__OyZ0Nq__hero",
  "heroActions": "pricing-page-module__OyZ0Nq__heroActions",
  "heroInner": "pricing-page-module__OyZ0Nq__heroInner",
  "highlight": "pricing-page-module__OyZ0Nq__highlight",
  "includedCheck": "pricing-page-module__OyZ0Nq__includedCheck",
  "includedSection": "pricing-page-module__OyZ0Nq__includedSection",
  "lead": "pricing-page-module__OyZ0Nq__lead",
  "lockStatus": "pricing-page-module__OyZ0Nq__lockStatus",
  "note": "pricing-page-module__OyZ0Nq__note",
  "page": "pricing-page-module__OyZ0Nq__page",
  "priceCard": "pricing-page-module__OyZ0Nq__priceCard",
  "priceCardBody": "pricing-page-module__OyZ0Nq__priceCardBody",
  "priceCardHead": "pricing-page-module__OyZ0Nq__priceCardHead",
  "pricingInner": "pricing-page-module__OyZ0Nq__pricingInner",
  "pricingSection": "pricing-page-module__OyZ0Nq__pricingSection",
  "primaryButton": "pricing-page-module__OyZ0Nq__primaryButton",
  "sectionInner": "pricing-page-module__OyZ0Nq__sectionInner",
  "trustList": "pricing-page-module__OyZ0Nq__trustList",
});
